import { Button } from "@/ui/shadcn/button";
import { useState, useEffect, useRef, useMemo } from "preact/hooks";
import { getL11nString } from "@/l11n/l11n";
import { uiLangIsRtl } from "@/l11n/l11n";
import { doLog } from "@/lib/globals";
import { isDesktop } from "@/lib/web";

export default function OtpInput({ onSubmit, onFocus, onBlur, placeholder }) {
  const [input, setInput] = useState("");
  const inputRef = useRef(null);
  const hasMounted = useRef(false);

  const strings = useMemo(
    () => ({
      submit: getL11nString("submit"),
    }),
    []
  );

  useEffect(() => {
    if (doLog()) console.log("OtpInput MOUNTED");

    // Handle mounting logic
    if (!hasMounted.current) {
      hasMounted.current = true;
      if (doLog()) console.log("OtpInput first mount, skipping focus set");
    } else {
      if (isDesktop) {
        if (doLog()) console.log("OtpInput is mounted & became visible, setting focus");
        setTimeout(() => {
          inputRef.current?.focus();
        }, 200);
      }
    }

    return () => {
      if (doLog()) console.log("OtpInput UNMOUNTED");
    };
  }, []);

  const handleSend = (e) => {
    e.preventDefault();
    if (input.trim()) {
      if (doLog()) console.log("handleSend", input);
      onSubmit(input);
      setInput("");
    }
  };

  const handleInput = (e) => {
    const value = e.target.value.replace(/\D/g, "").slice(0, 6);
    setInput(value);
  };

  const isRtl = uiLangIsRtl();

  const isValidOtp = () => {
    if (input.length !== 6) return false;
    if (!/^\d+$/.test(input)) return false;
    return true;
  };

  return (
    <form onSubmit={handleSend} className="flex w-full space-x-2 items-end">
      <input
        ref={inputRef}
        type="tel"
        name="otp"
        value={input}
        maxLength={6}
        pattern="[0-9]*"
        inputMode="numeric"
        autoFocus
        autoCorrect="off"
        spellCheck="false"
        autoCapitalize="off"
        autoComplete="one-time-code"
        onInput={handleInput}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
            handleSend(e);
          }
        }}
        placeholder={placeholder ?? "Enter verification code..."}
        className={`flex-1 h-10 w-full rounded-md border border-input bg-white px-2 py-1 text-lg shadow-sm transition-colors placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 ${
          isRtl ? "text-right" : "text-left"
        }`}
        onFocus={() => {
          if (doLog()) console.log("onFocus OtpInput");
          if (onFocus) onFocus();
        }}
        onBlur={() => {
          if (doLog()) console.log("onBlur OtpInput");
          if (onBlur) onBlur();
        }}
      />
      <Button type="submit" variant="taalia_std" disabled={!isValidOtp()}>
        {strings.submit}
      </Button>
    </form>
  );
}
